import * as S from '../footer/styles';

const Footer = () => {
  const getCurrentYear = () => {
    return new Date().getFullYear();
  };
  return (
    <S.Container>
      <S.Content>
        <img src="/assets/img/logo-estado.svg" width={45} />
        <span>© {getCurrentYear()} COTIN - Todos direitos reservados</span>
      </S.Content>
    </S.Container>
  );
};

export default Footer;
